import { useQuery, UseQueryOptions } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';
import { dateToISO8601 } from '../helpers/dates';
import { PerformancePeriodDTO } from '../types';

interface FetcherParams {
  clientId: number;
  period?: PerformancePeriodDTO;
  startDate?: string;
  endDate?: string;
  accountId: string;
  groupId: string;
}

export interface ProjectedIncomeDTO {
  chartData: {
    label: string;
    value: number;
  }[];
}

const fetchProjectedIncome = ({
  clientId,
  period,
  startDate,
  endDate,
  accountId,
  groupId,
}: FetcherParams): Promise<ProjectedIncomeDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OrionAccountsWidgets/ProjectedIncome', {
      clientId,
      period,
      startDate,
      endDate,
      accountId,
      groupId,
      localDate: dateToISO8601(),
    }),
  );
};

interface QueryParams {
  period?: PerformancePeriodDTO;
  startDate?: string;
  endDate?: string;
  accountId: string;
  groupId: string;
}

export const useProjectedIncomeQuery = (
  { period, startDate: _startDate, endDate: _endDate, accountId, groupId }: QueryParams,
  options?: UseQueryOptions<ProjectedIncomeDTO, Error>,
) => {
  const clientId = useClientId();
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  return useQuery(
    queryKeys.projectedIncome(clientId, period, startDate, endDate, accountId, groupId),

    () => fetchProjectedIncome({ clientId, period, startDate, endDate, accountId, groupId }),

    options,
  );
};
